export class ErrorBase {
  developerMessage: string;
  userMessage: string;
  errorCode: string;
  interactive: boolean;
}
